// Framework
//
// This file contains imports, such as React and other 3rd party libraries,
// that do not change frequently.
//
// adding random string to force recompile:
// A998D3152224818D225A880A9B627F1FB4484DD7E408EACA1B243326ED4AA01B
// General polifyll's
import 'core-js/es6/array';
// React polifyll's
import 'core-js/es6/promise'; // for IE 11 and below
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/modules/es6.object.assign';
import 'core-js/es6/string';
import 'raf/polyfill';
// React core
import 'react';
import 'react-dom';
/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';

// Strava
//
// This is the main entry point for react components. If you create a new
// component you will need to register in here.
//
// adding random string to force recompile:
// A998D3152224818D225A880A9B627F1FB4484DD7E408EACA1B243326ED4AA01B
import ReactComponentMounter from '../utils/react-component-mounter';

// Activity pages
import ActivityTagging from '../apps/activities/ActivityTagging';
import RelativeEffort from '../apps/activities/RelativeEffort';
import ExcludedEfforts from '../apps/activities/ExcludedEfforts';
import CorrectDistance from '../apps/activities/CorrectDistance/CorrectDistance';
import CorrectElevation from '../apps/activities/CorrectElevation/CorrectElevation';
// Settings pages
import EditPastActivitiesApp from '../apps/settings/EditPastActivitiesApp';
import PartnerIntegrationsApp from '../apps/settings/PartnerIntegrations';
import HideAddressApp from '../apps/settings/privacy/HideAddressApp';
import HideAnywhereApp from '../apps/settings/privacy/HideAnywhereApp';
// Subscription pages
import CheckoutApp from '../apps/subscriptions/Checkout';
import SummitPackageSelectUnpackedApp from '../apps/summit/PackageSelectUnpacked';
// Other pages
import RaceApp from '../apps/RaceApp';
import StarredSegment from '../components/StarredSegment';
import VisibilitySetting from '../components/VisibilitySetting';
import MapVisibilityControls from '../components/MapVisibilityControls';
import MentionableComment from '../components/MentionableComment';
import PerceivedExertionInput from '../components/PerceivedExertionInput';

ReactComponentMounter.register({
  ActivityTagging,
  RelativeEffort,
  ExcludedEfforts,
  CorrectDistance,
  CorrectElevation,
  EditPastActivitiesApp,
  PartnerIntegrationsApp,
  HideAddressApp,
  HideAnywhereApp,
  CheckoutApp,
  SummitPackageSelectUnpackedApp,
  RaceApp,
  StarredSegment,
  VisibilitySetting,
  MapVisibilityControls,
  MentionableComment,
  PerceivedExertionInput
});
